/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { TwsOrder, WebsocketStatus } from '../../utils/types';
import { wsClose, wsOpen, wsConnecting, wsError, wsMessage } from './actions';

export type SocketStore = {
    status: WebsocketStatus;
    data: Array<TwsOrder>;
    total: number;
    totalToday: number;
    connectionError: string;
};

const initialState: SocketStore = {
    status: WebsocketStatus.OFFLINE,
    data: [],
    total: 0,
    totalToday: 0,
    connectionError: '',
};

export const socketReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(wsConnecting, (state) => {
            state.status = WebsocketStatus.CONNECTING;
        })
        .addCase(wsOpen, (state) => {
            state.status = WebsocketStatus.ONLINE;
            state.connectionError = '';
        })
        .addCase(wsClose, (state) => {
            state.status = WebsocketStatus.OFFLINE;
        })
        .addCase(wsError, (state, action) => {
            state.connectionError = action.payload;
        })
        .addCase(wsMessage, (state, action) => {
            state.data = action.payload.orders;
            state.total = action.payload.total;
            state.totalToday = action.payload.totalToday;
        });
});
